import { render, staticRenderFns } from "./DepositDetailsView.vue?vue&type=template&id=22ea116c&"
import script from "./DepositDetailsView.vue?vue&type=script&lang=js&"
export * from "./DepositDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DepositDetailsView.vue?vue&type=style&index=0&id=22ea116c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports